import React from 'react';
import { ChevronRight, Palmtree } from 'lucide-react';

const Breadcrumbs = ({ path, onNavigate, currentModule, isMobile, fallbackName, fallbackId }) => {
  // console.log('Breadcrumbs:', { path, fallbackName, currentModule });
  const hasPath = path && path.length > 0;
  if (!hasPath && !fallbackName && !currentModule) return null;

  return (
    <div className={`flex items-center min-w-0 ${isMobile ? 'gap-1' : 'gap-2'}`}>
      {!isMobile && (
        <button
          onClick={() => onNavigate('/home')}
          data-testid="breadcrumb-home-btn"
          className="p-1 hover:bg-zinc-100 rounded-lg transition-colors text-zinc-400 hover:text-zinc-900 flex-shrink-0"
        >
          <Palmtree size={isMobile ? 14 : 16} />
        </button>
      )}

      {hasPath &&
        path.map((item, index) => (
          <React.Fragment key={item.id}>
            <ChevronRight size={isMobile ? 10 : 12} className="text-zinc-300 flex-shrink-0" />
            <button
              onClick={() => onNavigate?.(`/p/${item.id}`)}
              data-testid={`breadcrumb-link-${item.id}`}
              className={`text-xs font-bold truncate transition-colors hover:text-zinc-900 ${
                index === path.length - 1 && !currentModule ? 'text-zinc-900' : 'text-zinc-400'
              }`}
            >
              {item.name}
            </button>
          </React.Fragment>
        ))}

      {!hasPath && fallbackName && (
        <>
          <ChevronRight size={isMobile ? 10 : 12} className="text-zinc-300 flex-shrink-0" />
          {onNavigate ? (
            <button
              onClick={() => onNavigate(`/p/${fallbackId}`)}
              className="text-xs font-bold text-zinc-400 truncate hover:text-zinc-900 transition-colors"
            >
              {fallbackName}
            </button>
          ) : (
            <span className="text-xs font-bold text-zinc-400 truncate">{fallbackName}</span>
          )}
        </>
      )}

      {currentModule && (
        <>
          <ChevronRight size={isMobile ? 10 : 12} className="text-zinc-300 flex-shrink-0" />
          <span className="text-xs font-black uppercase tracking-widest text-zinc-900 flex-shrink-0">
            {currentModule}
          </span>
        </>
      )}
    </div>
  );
};

export default Breadcrumbs;
